import React, {createRef} from 'react'
import {findDOMNode} from "react-dom"

import DNDPreviewLayerComponent, {
    DNDPreviewLayerProps
} from "../../../gd-modules/dnd/preview-layer/dnd-preview-layer-component"
import ReorderItem from "../reorder-item"

type Props = {
    className? : string
} & DNDPreviewLayerProps

export default class ReorderListPreviewLayer extends DNDPreviewLayerComponent<Props, any> {

    private previewRef: any = createRef()

    showPreview(source: any, mouseEvent: React.MouseEvent) {
        this.initialPreviewSourceRect = source.getInitialRect();

        this.setState({
            source: source
        }, ()=>{
            this.previewNode = findDOMNode(this.previewRef.current);

            // detect if reorder-preview-layer is displaced on the screen and compensate displacement
            // (may be caused by parent 'transition' css property)
            const node: any = findDOMNode(this)
            const rect = node.getBoundingClientRect()
            node.style.setProperty('left', "{0}px".f(-rect.x))
            node.style.setProperty('top', "{0}px".f(-rect.y))
            node.style.setProperty('width', "{0}px".f(window.innerWidth))
            node.style.setProperty('height', "{0}px".f(window.innerHeight))

            this.updatePreview();
        });
    }

    hidePreview() {
        this.initialPreviewSourceRect = null;
        this.previewNode = null;

        this.setState({
            source: null
        });
    }

    updatePreview(dx = 0, dy = 0) {
        if (!this.initialPreviewSourceRect) return;

        if (this.initialPreviewSourceRect) {
            this.previewNode.style.setProperty("position", "absolute");
            this.previewNode.style.setProperty("left", (this.initialPreviewSourceRect.left + dx) + "px");
            this.previewNode.style.setProperty("top", (this.initialPreviewSourceRect.top + dy) + "px");
            this.previewNode.style.setProperty("width", this.initialPreviewSourceRect.width + "px");
            this.previewNode.style.setProperty("height", this.initialPreviewSourceRect.height + "px");
        }
    }

    render() {
        if (!this.state.source) return null;

        return (
            <div className={Classes("reorder-preview-layer", this.props.className)}>
                <ReorderItem ref                        = {this.previewRef}
                             data                       = {this.state.source.props.data}
                             disableMouseMoveListeners  = {true}
                             disableMouseEnterListeners = {true}>
                    {React.cloneElement(this.state.source.props.data.component, {dndPreview: true})}
                </ReorderItem>
            </div>
        );
    }
}